@if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
  <form [formGroup]="activeQuestion">
    <div class="question-form__array with-actions">
      <div class="header row">
        <span class="label">Options <span class="fs__xs caption">(Must have at least 2 options)</span></span>

        <div class="question-form__array__actions">
          <button mat-button color="primary" (click)="onAddOptionsSet()">
            <fa-icon [icon]="faPlus"></fa-icon>
            From library
          </button>

          <button mat-icon-button color="light" (click)="onSortOrder('asc')">
            <fa-icon [icon]="faArrowDownAZ"></fa-icon>
          </button>

          <button mat-icon-button color="light" (click)="onSortOrder('desc')">
            <fa-icon [icon]="faArrowUpZA"></fa-icon>
          </button>

          <mat-divider [vertical]="true"></mat-divider>

          <mat-slide-toggle
            [labelPosition]="'before'"
            [color]="'primary'"
            formControlName="randomizedOptionsInd"
            [checked]="activeQuestion.value.randomizedOptionsInd"
          >
            Randomized
          </mat-slide-toggle>
        </div>
      </div>

      <div formArrayName="options" cdkDropList class="question-form_array_list" (cdkDropListDropped)="drop($event)">
        @for (optionCtrl of options.controls; track $index) {
          @if (activeQuestion.get('useOtherInd').value && activeQuestion.get('useOtherPosition')?.value === $index) {
            <div cdkDrag class="question-form_array_draggable">
              <ng-container *ngTemplateOutlet="other"></ng-container>
            </div>
          }

          <div cdkDrag class="question-form_array_draggable">
            <div [formGroupName]="$index" class="question-form__array__input">
              <div *cdkDragPlaceholder class="drag-placeholder"></div>
              <fa-icon [class.eiq-hide]="options.controls.length === 1" [icon]="faGripDotsVertical" title="Re-order option" cdkDragHandle></fa-icon>

              <empathy-text-editor
                [id]="optionCtrl.value.id"
                [control]="optionCtrl.get('text')"
                [autofocus]="justAddedOptionId === optionCtrl.value.id"
                [stopDefaultTab]="true"
                [hasMedia]="!!optionCtrl.value.stimulus?.mediaId"
                [splitOnPaste]="true"
                (tab)="onAddOption($last, $index)"
                (paste)="onPaste($event, $index)"
              >
                <div slot="prefix" class="eiq-id-badge">
                  <span>{{ optionCtrl.value.id }}</span>
                </div>
                <div slot="suffix" class="actions">
                  @if (![questionType.Dropdown, questionType.RankSort, questionType.Ranking].includes(activeQuestion.value.type)) {
                    @if (optionCtrl.value.stimulus?.mediaId) {
                      <empathy-shared-stimulus
                        [stimulus]="[optionCtrl.value.stimulus]"
                        [height]="55"
                        [width]="82"
                        (delete)="onDeleteMedia($index)"
                      ></empathy-shared-stimulus>
                    } @else {
                      <button mat-icon-button [color]="'primary'" title="Add stimulus to this option" (click)="onAddStimulus($index)">
                        <fa-icon [icon]="faImage"></fa-icon>
                      </button>
                    }
                  }

                  <button
                    mat-icon-button
                    [color]="!optionCtrl.get('pinnedPositionInd').value ? 'primary' : 'alert'"
                    title="Pin Option Position"
                    [class.rotate-icon]="!optionCtrl.get('pinnedPositionInd').value"
                    [class.pinned]="optionCtrl.get('pinnedPositionInd').value"
                    (click)="optionCtrl.get('pinnedPositionInd').setValue(!optionCtrl.get('pinnedPositionInd').value)"
                  >
                    <fa-icon [icon]="faThumbTack"></fa-icon>
                  </button>

                  @if (activeQuestion.value.type === questionType.MultiChoice || activeQuestion.value.type === questionType.CarouselMultiChoice) {
                    <button
                      mat-icon-button
                      title="Make option exclusive"
                      [class.pinned]="optionCtrl.get('exclusiveInd').value"
                      [color]="!optionCtrl.get('exclusiveInd').value ? 'primary' : 'alert'"
                      (click)="optionCtrl.get('exclusiveInd').setValue(!optionCtrl.get('exclusiveInd').value)"
                    >
                      <fa-icon [icon]="!optionCtrl.get('exclusiveInd').value ? faStar : faStarSolid"></fa-icon>
                    </button>
                  }

                  <button mat-icon-button color="primary" title="Option conditions" (click)="onOpenConditionals(optionCtrl)">
                    <fa-icon [icon]="faCodeBranch"></fa-icon>
                  </button>

                  @if (options.controls.length > 2) {
                    <button mat-icon-button color="warn" title="Delete Option" (click)="onRemoveAt($index, optionCtrl.get('id').value)">
                      <fa-icon [icon]="faTrashCan"></fa-icon>
                    </button>
                  }
                </div>
              </empathy-text-editor>
              <fa-icon
                title="Option has conditions"
                color="alert"
                [class.eiq-hide]="optionCtrl.get('visibleWhen').value.length === 0"
                [icon]="faCodeBranch"
              ></fa-icon>
            </div>
          </div>

          @if (activeQuestion.get('useOtherPosition')?.value >= options.length && $last) {
            <div cdkDrag class="question-form_array_draggable">
              <ng-container *ngTemplateOutlet="other"></ng-container>
            </div>
          }
        }
      </div>

      @if (allowNone() && activeQuestion.get('useNoneInd').value) {
        <div class="choice-form__none-container">
          <div class="choice-form__none-container__title">
            <span class="label">None</span>
          </div>
          <div class="choice-form__none-container__input">
            <empathy-text-editor [id]="'NONE'" [control]="activeQuestion.get('noneLabel')">
              <div slot="prefix" class="eiq-id-badge">
                <span>NONE</span>
              </div>
              <div slot="suffix" class="actions">
                <button mat-icon-button color="warn" title="Toggle off None option" (click)="onSetNone(false, activeQuestion)">
                  <fa-icon [icon]="faTrashCan"></fa-icon>
                </button>
              </div>
            </empathy-text-editor>
          </div>
        </div>
      }

      <div class="footer">
        <button mat-button color="primary" [disabled]="!addOptionAllowed$()" (click)="onAddOption(true)">
          <fa-icon [icon]="faPlus"></fa-icon>
          New Option
        </button>
        @if (allowOther() && !activeQuestion.get('useOtherInd').value) {
          <button mat-button color="primary" title="Toggle on Other option" (click)="onSetOther(true)">
            <fa-icon [icon]="faPlus"></fa-icon>
            Other, please specify
          </button>
        }
        @if (allowNone() && !activeQuestion.get('useNoneInd').value) {
          <button mat-button color="primary" title="Toggle on None option" (click)="onSetNone(true, activeQuestion)">
            <fa-icon [icon]="faPlus"></fa-icon>
            None of these
          </button>
        }
      </div>
    </div>
  </form>

  <ng-template #other>
    <div class="choice-form__other-container">
      <div *cdkDragPlaceholder class="drag-placeholder"></div>
      <fa-icon [class.eiq-hide]="options.controls.length === 1" [icon]="faGripDotsVertical" title="Re-order option" cdkDragHandle></fa-icon>

      <div class="choice-form__other-container__input">
        <empathy-text-editor [id]="'OTHER'" [control]="activeQuestion.get('otherLabel')">
          <div slot="prefix" class="eiq-id-badge">
            <span>OTHER</span>
          </div>
          <div slot="suffix" class="actions">
            <button
              mat-icon-button
              [color]="!activeQuestion.get('useOtherPinnedInd').value ? 'primary' : 'alert'"
              title="Pin Other Position"
              [class.rotate-icon]="!activeQuestion.get('useOtherPinnedInd').value"
              [class.pinned]="activeQuestion.get('useOtherPinnedInd').value"
              (click)="activeQuestion.get('useOtherPinnedInd').setValue(!activeQuestion.get('useOtherPinnedInd').value)"
            >
              <fa-icon [icon]="faThumbTack"></fa-icon>
            </button>

            @if (activeQuestion.get('useExclusiveOtherInd')) {
              <eiq-icon-button
                [color]="activeQuestion.get('useExclusiveOtherInd').value ? 'alert' : 'primary'"
                [icon]="activeQuestion.get('useExclusiveOtherInd').value ? faStarSolid : faStar"
                (clicked)="activeQuestion.get('useExclusiveOtherInd').setValue(!activeQuestion.get('useExclusiveOtherInd').value)"
              ></eiq-icon-button>
            }

            <button mat-icon-button color="warn" title="Toggle off Other option" (click)="onSetOther(false)">
              <fa-icon [icon]="faTrashCan"></fa-icon>
            </button>
          </div>
        </empathy-text-editor>
      </div>
    </div>
  </ng-template>
}
